import {
  SELECT_DOC_TYPE,
  PREVIEW,
  RETRY,
  RESET_RETRIES,
  SET_CROPPED_IMAGE,
  CREATE_INSTANCE,
  FIRST_TIME_INIT,
  RETRY_PROCESSING,
  IS_SINGLE_PAGED,
  SET_DOCUMENT_QUALITY_RETRIES,
  RETRY_DOCUMENT_QUALITY,
  RESET_ALL_RETRIES_FAILED,
  RESETING_DOCUMENT_QUALITY_RETRIES,
  COUNTRY_SELECTOR,
  CAMERA_CHANGED,
  MODAL_SHOWED,
  DOCUMENT_CAPTURE_CONFIG,
  CAMERA_RESOLUTION,
  COUNTRY_NUM,
} from "../actions/documentCapture";

const defaultState = {
  firstTimeInitialized: false,
  documentType: undefined,
  blobFirstPage: undefined,
  blobSecondPage: undefined,
  base64CroppedFirstPage: undefined,
  base64CroppedSecondPage: undefined,
  documentQualityRetriesFront: undefined,
  documentQualityRetriesBack: undefined,
  retries: 0,
  message: undefined,
  processingRetriesCounter: 0,
  singlePaged: false,
  allRetriesFailed: false,
  docCountryOptions: {
    id: undefined,
    dl: undefined,
  },
  numOfFrames: undefined,
  initialCaptureDelay: undefined,
  captureInterval: undefined,
  width: undefined,
  height: undefined,
  timeout: undefined,
  cameraId: "",
  count: 0,
  dialCountryNum: "other",
  summaryScorePresent: undefined,
};

export function documentCapture(state = defaultState, action) {
  switch (action.type) {
    case CREATE_INSTANCE:
      return {
        ...state,
        docCaptureInstance: action.payload,
      };
    case FIRST_TIME_INIT:
      return {
        ...state,
        firstTimeInitialized: true,
      };
    case SELECT_DOC_TYPE:
      return {
        ...state,
        blobFirstPage: undefined,
        blobSecondPage: undefined,
        base64CroppedFirstPage: undefined,
        base64CroppedSecondPage: undefined,
        documentType: action.payload,
        retries: 0,
      };
    case PREVIEW:
      if (state.base64CroppedFirstPage) {
        return {
          ...state,
          blobSecondPage: action.payload.blob,
          base64CroppedSecondPage: action.payload.base64,
          message: action.payload.message,
          isRejected: action.payload.isRejected,
          captureMethod: action.payload.captureMethod,
          allRetriesFailed: action.payload.allRetriesFailed,
          isBadQualityImage: action.payload.isBadQualityImage,
          summaryScorePresent: action.payload.summaryScorePresent,
        };
      }
      return {
        ...state,
        blobFirstPage: action.payload.blob,
        base64CroppedFirstPage: action.payload.base64,
        blobSecondPage: undefined,
        base64CroppedSecondPage: undefined,
        message: action.payload.message,
        isRejected: action.payload.isRejected,
        captureMethod: action.payload.captureMethod,
        allRetriesFailed: action.payload.allRetriesFailed,
        isBadQualityImage: action.payload.isBadQualityImage,
        summaryScorePresent: action.payload.summaryScorePresent,
      };
    case RESET_ALL_RETRIES_FAILED: {
      return {
        ...state,
        allRetriesFailed: false,
        isBadQualityImage: false,
      };
    }
    case RESET_RETRIES: {
      return {
        ...state,
        retries: 0,
      };
    }
    case SET_DOCUMENT_QUALITY_RETRIES: {
      return {
        ...state,
        documentQualityRetriesFront: action.payload,
        documentQualityRetriesBack: action.payload,
      };
    }
    case RETRY_DOCUMENT_QUALITY: {
      if (action.payload === "front") {
        return {
          ...state,
          documentQualityRetriesFront: state.documentQualityRetriesFront - 1,
        };
      } else {
        return {
          ...state,
          documentQualityRetriesBack: state.documentQualityRetriesBack - 1,
        };
      }
    }
    case RETRY:
      return {
        ...state,
        //delete only if we didn't go to second page yet
        blobFirstPage: state.blobSecondPage ? state.blobFirstPage : undefined,
        blobSecondPage: undefined,
        croppedResponseBase64: undefined,
        retries: state.retries + 1,
        base64CroppedFirstPage: state.base64CroppedSecondPage
          ? state.base64CroppedFirstPage
          : undefined,
        base64CroppedSecondPage: undefined,
      };
    case SET_CROPPED_IMAGE: {
      return {
        ...state,
        croppedResponseBase64: action.payload,
      };
    }
    case RETRY_PROCESSING: {
      return {
        ...state,
        blobFirstPage: undefined,
        blobSecondPage: undefined,
        croppedResponseBase64: undefined,
        processingRetriesCounter: state.processingRetriesCounter + 1,
      };
    }
    case IS_SINGLE_PAGED: {
      return {
        ...state,
        singlePaged: action.payload,
      };
    }
    case RESETING_DOCUMENT_QUALITY_RETRIES: {
      if (action.payload === "front") {
        return {
          ...state,
          documentQualityRetriesFront:
            state.documentQualityRetriesFront < 3
              ? 3
              : state.documentQualityRetriesFront,
        };
      } else {
        return {
          ...state,
          documentQualityRetriesBack:
            state.documentQualityRetriesBack < 3
              ? 3
              : state.documentQualityRetriesBack,
        };
      }
    }
    case MODAL_SHOWED: {
      return {
        ...state,
        count: state.count + 1,
      };
    }
    case COUNTRY_SELECTOR: {
      return {
        ...state,
        docCountryOptions: action.payload,
      };
    }
    case CAMERA_CHANGED: {
      return {
        ...state,
        cameraId: action.payload,
      };
    }
    case DOCUMENT_CAPTURE_CONFIG: {
      console.log(action.payload);
      return {
        ...state,
        numOfFrames: action.payload.numOfFrames,
        captureInterval: action.payload.captureInterval,
        initialCaptureDelay: action.payload.initialCaptureDelay,
        timeout: action.payload.timeout,
      };
    }
    case CAMERA_RESOLUTION: {
      return {
        ...state,
        width: action.payload.width,
        height: action.payload.height,
      };
    }
    case COUNTRY_NUM: {
      return {
        ...state,
        dialCountryNum: action.payload,
      };
    }
    default:
      return state;
  }
}
